import { useCallback, useEffect, useRef } from 'react';
import { useFormFieldArray } from '../../AdditionalFormContext';
import {
  useFormTableName,
  useFormTableSequenceNumberColumn,
} from './TanstackFormTable';
import { useUpdateSequenceNumbersRef } from './useUpdateSequenceNumbersRef';

export const useRemoveFormTableRow = () => {
  const name = useFormTableName();
  const { hasSequenceNumberColumn, sequenceNumberFieldName } =
    useFormTableSequenceNumberColumn();
  const updateSequenceNumbers = useUpdateSequenceNumbersRef(
    name,
    sequenceNumberFieldName
  );
  const { remove } = useFormFieldArray(name);
  const methodRef = useRef<(index: number | number[]) => void>(undefined!);

  useEffect(() => {
    methodRef.current = (index: number | number[]) => {
      remove(index);

      if (hasSequenceNumberColumn) {
        updateSequenceNumbers.current(
          Array.isArray(index) ? Math.min(...index) : index
        );
      }
    };
  }, [
    remove,
    hasSequenceNumberColumn,
    sequenceNumberFieldName,
    updateSequenceNumbers,
  ]);

  return useCallback(
    (index: number | number[]) => {
      methodRef.current(index);
    },
    [methodRef]
  );
};
